<div class="wrapper">
    <div class="row field date-input">
        <span class="label col-auto">{{ labelDate }}</span>
        <div class="col row">
            <div class="date-picker col">
                <input id="sDatepicker" type="text" datepicker (dateEventEmitter)="sDateEventEmitter($event)" [Date]="sDate"
                    [isMonthYear]="hiddenDate" placeholder='{{"common.lbl.027" | translate}}' autocomplete="off">
            </div>
            <span class="lb col-auto">-</span>
            <div class="date-picker col">
                <input id="eDatepicker" type="text" datepicker (dateEventEmitter)="eDateEventEmitter($event)" [Date]="eDate"
                    [isMonthYear]="hiddenDate" placeholder='{{"common.lbl.028" | translate}}' autocomplete="off">
            </div>
        </div>        
    </div>

    <div class="row field date-search">
        <div class="label col-auto">
            <span>{{ labelDate }} {{searchByLabelDate}}</span>
        </div>
        <select-dropdown class="dropdown-select col row" [options]="dateOptions" [selected]="dateOptions[0]"
            (changeSelectedValue)="hanldeOnGetDateSelectedValue($event);">
        </select-dropdown>
        <div class="w-btn col-auto btn-all" id="search" (click)="handleOnClickAll();">
            <span>{{"common.013" | translate}}</span>
        </div>
    </div>
</div>